<div class="container" id="top">
    <h2>Institutional Account List</h2>
    <p class="excludesMessage">Excludes future dated chartfield values</p>
  <p *ngIf="iacctRange !== null">{{iacctRange.rangeStart | noComma }} - {{iacctRange.rangeEnd
    |
    noComma }} Series: {{iacctRange.rangeName}}</p>
  <p style="width:100%" *ngIf="iacctRange !== null" [innerHTML]="iacctRange.rangeExample"></p>

  <p class="returnTop">
    <span *ngIf="prevIacctRange"><a [routerLink]="['/introduction/iact/iact-list', prevIacctRange.rangeId]">&lt;
        Previous
        ({{prevIacctRange.rangeStart | noComma }}-{{prevIacctRange.rangeEnd | noComma
        }})</a></span>
    <span *ngIf="prevIacctRange && nextIacctRange"> | </span>
    <span *ngIf="nextIacctRange"><a [routerLink]="['/introduction/iact/iact-list', nextIacctRange.rangeId]">Next
        ({{nextIacctRange.rangeStart | noComma }}-{{nextIacctRange.rangeEnd | noComma
        }}) &gt;</a></span>
  </p>
  <div class="border border-secondary mb-4">
      <table class="table table-hover table-sm mb-0">
          <thead>
          <tr>
              <th>Iact</th>
              <th style="min-width: 260px;">Description</th>
              <th>Purpose</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let iacct of iaccts">
              <td>{{iacct.elementCode}}</td>
              <td>{{iacct.description}}</td>
              <td [innerHTML]="iacct.longDescription"></td>
          </tr>
          </tbody>
      </table>
  </div>

    <p *ngIf="iaccts && getDescriptionCount() > 0" class="returnTop">
    <span *ngIf="prevIacctRange"><a [routerLink]="['/introduction/iact/iact-list', prevIacctRange.rangeId]">&lt;
        Previous
        ({{prevIacctRange.rangeStart | noComma }}-{{prevIacctRange.rangeEnd | noComma
        }})</a></span>
    <span *ngIf="prevIacctRange!==null && nextIacctRange!==null"> | </span>
    <span *ngIf="nextIacctRange!==null"><a [routerLink]="['/introduction/iact/iact-list', nextIacctRange.rangeId]">Next
        ({{nextIacctRange.rangeStart | noComma }}-{{nextIacctRange.rangeEnd | noComma
        }}) &gt;</a></span>
  </p>

</div>